import Icon from '@Shared/Icon';
import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

interface Props {
  show: boolean
}

const ContactAdminSubmit: React.FC<Props> = (props) => {

  return props.show ? (
    <Row style={{ marginTop: -9 }}>
      <Col xs={12}>
        <Form.Group className='form-group'>
          <hr />
          <div style={{ paddingTop: 14 }}>
            <Button type='submit' variant='primary'>
              <Icon name='upload fas' /> Send Message
            </Button>
          </div>
        </Form.Group>
      </Col>
    </Row >
  ) : null;
}

export default ContactAdminSubmit;